import React, { useState, useEffect } from 'react';
import atlaslogo from './Atlas-Final Logo (1).png';

const navItems = [
  { label: 'Features', id: 'features' },
  { label: 'Modules', id: 'modules' },
  { label: 'How It Works', id: 'how-it-works' },
  { label: 'Security', id: 'privacy' },
  { label: 'Pricing', id: 'pricing' },
];

const styles = {
  nav: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    gap: '24px',
    padding: '0 48px', height: '68px',
    transition: 'background 0.3s, border-bottom 0.3s',
  },
  navScrolled: {
    background: 'rgba(10,15,30,0.95)',
    backdropFilter: 'blur(12px)',
    borderBottom: '1px solid rgba(255,255,255,0.07)',
  },
  logo: {
    display: 'flex', alignItems: 'center',
    border: 0,
    background: 'transparent',
    padding: 0,
  },
  logoImage: {
    width: '54px',
    height: '58px',
    borderRadius: '8px',
    objectFit: 'contain',
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    gap: '28px',
  },
  link: {
    background: 'transparent',
    color: '#a8b4cc',
    fontSize: '14px',
    fontWeight: 600,
    padding: '8px 0',
    transition: 'color 0.2s',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
  },
  cta: {
    background: 'linear-gradient(135deg, #2d6a4f, #40916c)',
    color: '#fff',
    padding: '10px 18px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 700,
    boxShadow: '0 12px 32px rgba(45,106,79,0.28)',
    whiteSpace: 'nowrap',
  },
  menuButton: {
    display: 'none',
    width: '42px',
    height: '42px',
    borderRadius: '8px',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '5px',
  },
  menuLine: {
    width: '18px',
    height: '2px',
    background: '#fff',
    borderRadius: '99px',
  },
  mobileMenu: {
    display: 'none',
    position: 'absolute',
    top: '68px',
    left: '16px',
    right: '16px',
    padding: '14px',
    background: 'rgba(10,15,30,0.98)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '8px',
    boxShadow: '0 18px 48px rgba(0,0,0,0.35)',
  },
  mobileLink: {
    width: '100%',
    textAlign: 'left',
    background: 'transparent',
    color: '#a8b4cc',
    fontSize: '15px',
    fontWeight: 600,
    padding: '12px',
    borderRadius: '8px',
  },
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);

    if (id === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav style={{ ...styles.nav, ...(scrolled ? styles.navScrolled : {}) }}>
      <button type="button" aria-label="Go to top" style={styles.logo} onClick={() => scrollTo('top')}>
        <img
          src={atlaslogo}
          alt="ATLAS Logo"
          style={styles.logoImage}
        />
      </button>

      <div className="atlas-nav-links" style={styles.links}>
        {navItems.map((item) => (
          <button
            key={item.id}
            type="button"
            style={styles.link}
            onMouseEnter={(e) => { e.currentTarget.style.color = '#ffffff'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = '#a8b4cc'; }}
            onClick={() => scrollTo(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="atlas-nav-actions" style={styles.actions}>
        <button type="button" style={styles.cta} onClick={() => scrollTo('book-a-demo')}>
          Book a Demo
        </button>
        <button
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          className="atlas-menu-button"
          style={styles.menuButton}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span style={styles.menuLine} />
          <span style={styles.menuLine} />
          <span style={styles.menuLine} />
        </button>
      </div>

      <div className={`atlas-mobile-menu ${menuOpen ? 'is-open' : ''}`} style={styles.mobileMenu}>
        {navItems.map((item) => (
          <button
            key={item.id}
            type="button"
            style={styles.mobileLink}
            onClick={() => scrollTo(item.id)}
          >
            {item.label}
          </button>
        ))}
        <button type="button" style={{ ...styles.mobileLink, ...styles.cta, marginTop: '6px', textAlign: 'center' }} onClick={() => scrollTo('book-a-demo')}>
          Book a Demo
        </button>
      </div>

      <style>{`
        @media (max-width: 860px) {
          .atlas-nav-links { display: none !important; }
          .atlas-nav-actions > button:first-child { display: none !important; }
          .atlas-menu-button { display: flex !important; }
          .atlas-mobile-menu.is-open { display: block !important; }
        }

        @media (max-width: 560px) {
          nav { padding-left: 20px !important; padding-right: 20px !important; }
        }
      `}</style>
    </nav>
  );
}
